export const WINE_TYPE: number = 1;
export const ADD_TYPE: number = 2;
export const WINE_TYPES: number[] = [WINE_TYPE, ADD_TYPE];
export const CONTENT_TYPE: number = 3;
